import * as React from "react";
import { Routes, Route } from "react-router-dom";

import { UnderRecycle } from "../../pages/erro/UnderRecycle";
import { NotFound } from "../../pages/erro/NotFound";
import { UnderConstruction } from "../../pages/erro/UnderConstruction";

import Page from "../../pages/default/page";
import ParceiroPage from "../../pages/parceiros/main";
import ParceiroPageDetalhe from "../../pages/parceiros/detalhe";
import { ParametroPage } from "../../pages/parametrosDomain/main";
import { ParametroParceiroPage } from "../../pages/parametrosParceiro/main";
import { RegraPage } from "../../pages/regras/main";
import ContratoPage from "../../pages/contratos/main";
import RelacaoDeContrato from "../../pages/contratos/relacaoDeContrato";
import { UsuarioPage } from "../../pages/usuarios/main";
import { DadosBasicosPage } from "../../pages/dadosbasicos/main";
import ForecastPage from "../../pages/forecast/detalhe";
import ForecastDiarioPage from "../../pages/forecastDiario/detalhe";
import SolicitacaoMaterialPage from "../../pages/materiaPrima/detalhe";
import ForecastSelection from "../../pages/forecastSelection/main";
import { LancamentoProducaoPage } from "../../pages/lancamentoDiario/main";
import ProdutoAcabadoPage from "../../pages/produtoAcabado/detalhe";
import { JustificativasPage } from "../../pages/justificativas/main";
//import { Forbidden } from "../../pages/erro/forbidden";
import Usuario from "../../components/classes/Usuario";
import Regra from "../../components/classes/Regra";
import Header from "../common/header";
import { ProjetoPage } from "../../pages/projetos/main";
import { PropriedadePage } from "../../pages/propriedade/main";
import UsuarioDataset from "../data/UsuarioDataSet";
import { DashboardOtifPage } from "../../pages/dashboardOtif/main";
import PedidosImportacao from "../../pages/pedidoImportacao/PedidosImportacao";
import EstoqueEmbalagensPage from "../../pages/estoqueBRF/main";
import EstoqueParceiroPage from "../../pages/estoqueParceiro/main";
import ParceiroAgregadoPage from "../../pages/parceiroAgregado/main";
import ParametroPortalPage from "../../pages/parametroPortal/main";
import { DashboardImportPage } from "../../pages/dashboardImport/main";
import { DashboardConsumoPage } from "../../pages/dashboardConsumo/main";

import AcompanhamentoCargaFOBPage from "../../pages/acompanhamentoCargaFOB/main";
import AcompanhamentoCargaCIFPage from "../../pages/acompanhamentoCargaCIF/main";
import AcompanhamentoCargaMateriaPrimaPage from "../../pages/acompanhamentoCargaMateriaPrima/main";
import GrupoEmailsPage from "../../pages/grupoEmails/main";
import { PasswordPage } from "../../pages/password/main";
import { DashboardAcompParceirosPage } from "../../pages/dashboardAcompParceiros/main";
import ProtectedRoute from "../common/ProtectedRoute";

const usuarioDataSet = new UsuarioDataset();

const RootPath = () => {
  return (
    <React.Fragment>
      <Header />
      <Routes>
        <Route path="/" element={<Page />} />
        <Route path="/notfound" element={<NotFound />} />
        <Route path="/portal/parametroPortal" element={<ParametroPortalPage />} />
        <Route path="/portal/propriedade" element={<ProtectedRoute><PropriedadePage /></ProtectedRoute>} />
        <Route path="/portal/parceiro" element={<ParceiroPage />} />
        <Route path="/portal/parceiro/detalhe/:id" element={<ParceiroPageDetalhe />} />
        <Route path="/portal/parceiroAgregado" element={<ProtectedRoute><ParceiroAgregadoPage /></ProtectedRoute>} />
        <Route path="/portal/parametros" element={<ParametroPage />} />
        <Route path="/portal/parceiro/parametros" element={<ProtectedRoute><ParametroParceiroPage /></ProtectedRoute>} />
        <Route path="/portal/perfil" element={<UnderConstruction />} />
        <Route path="/portal/usuario" element={<UsuarioPage />} />
        <Route path="/portal/password" element={<PasswordPage />} />
        <Route path="/portal/dadosBasicos" element={<DadosBasicosPage />} />
        <Route path="/portal/sso" element={<UnderConstruction />} />
        <Route path="/portal/grupoemail" element={<GrupoEmailsPage />} />
        <Route path="/planejamento/contratos" element={<ProtectedRoute><RelacaoDeContrato /></ProtectedRoute>} />
        <Route path="/contrato/detalhe" element={<ProtectedRoute><ContratoPage /></ProtectedRoute>} />
        <Route path="/planejamento/forecast" element={<ProtectedRoute><ForecastPage /></ProtectedRoute>} />
        <Route path="/planejamento/forecastDia" element={<ProtectedRoute><ForecastDiarioPage /></ProtectedRoute>} />
        <Route path="/planejamento/materiaprima" element={<ProtectedRoute><SolicitacaoMaterialPage /></ProtectedRoute>} />
        <Route path="/planejamento/projetos" element={<ProtectedRoute><ProjetoPage /></ProtectedRoute>} />
        <Route path="/planejamento/justificativas" element={<ProtectedRoute><JustificativasPage /></ProtectedRoute>} />
        <Route path="/producao/lancamentoProducao" element={<ProtectedRoute><LancamentoProducaoPage /></ProtectedRoute>} />
        <Route path="/entrega/produtoAcabado" element={<ProtectedRoute><ProdutoAcabadoPage /></ProtectedRoute>} />
        <Route path="/pedidos/pedidoImportacao" element={<ProtectedRoute><PedidosImportacao /></ProtectedRoute>} />
        <Route path="/dashboard/otifDashboard" element={<ProtectedRoute requiresPartner={false}><DashboardOtifPage /></ProtectedRoute>} />
        <Route path="/dashboard/consumoContratual" element={<ProtectedRoute requiresPartner={false}><DashboardConsumoPage /></ProtectedRoute>} />
        <Route path="/dashboard/importacao" element={<ProtectedRoute requiresPartner={false}><DashboardImportPage /></ProtectedRoute>} />
        <Route path="/dashboard/acompanhamentoParceiros" element={<ProtectedRoute requiresPartner={false}><DashboardAcompParceirosPage /></ProtectedRoute>} />
        <Route path="/estoque/parceirobrf" element={<ProtectedRoute><EstoqueEmbalagensPage /></ProtectedRoute>} />
        <Route path="/estoque/parceiro" element={<ProtectedRoute><EstoqueParceiroPage /></ProtectedRoute>} />
        <Route path="/entrega/acompanhamentoFOB" element={<ProtectedRoute><AcompanhamentoCargaFOBPage /></ProtectedRoute>} />
        <Route path="/entrega/acompanhamentoCIF" element={<ProtectedRoute><AcompanhamentoCargaCIFPage /></ProtectedRoute>} />
        <Route path="/entrega/acompanhamentoMateriaPrima" element={<ProtectedRoute><AcompanhamentoCargaMateriaPrimaPage /></ProtectedRoute>} />
        <Route path="/teste" element={<ForecastSelection />} />     
      </Routes>
    </React.Fragment>
  );
}


const SUPORTEBRFPath = () => {
  return (
    <React.Fragment>
      <Header />
      <Routes>
        <Route path="/" element={<Page />} />
        <Route path="/notfound" element={<NotFound />} />       
        <Route path="/portal/propriedade" element={<PropriedadePage />} />
        <Route path="/portal/parceiro" element={<ParceiroPage />} />
        <Route path="/portal/parceiro/detalhe/:id" element={<ParceiroPageDetalhe />} />
        <Route path="/portal/parametros" element={<ParametroPage />} />
        <Route path="/portal/perfil" element={<UnderConstruction />} />
        <Route path="/portal/usuario" element={<UsuarioPage />} />
        <Route path="/portal/password" element={<PasswordPage />} />
        <Route path="/portal/dadosBasicos" element={<DadosBasicosPage />} />
        <Route path="/portal/sso" element={<UnderConstruction />} />
        <Route path="/portal/grupoemail" element={<GrupoEmailsPage />} />
        <Route path="/planejamento/contratos" element={<RelacaoDeContrato />} />
        <Route path="/contrato/detalhe" element={<ContratoPage />} />
        <Route path="/planejamento/forecast" element={<ForecastPage />} />
        <Route path="/planejamento/forecastDia" element={<ForecastDiarioPage />} />
        <Route path="/planejamento/materiaprima" element={<SolicitacaoMaterialPage />} />
        <Route path="/planejamento/projetos" element={<ProjetoPage />} />
        <Route path="/planejamento/justificativas" element={<JustificativasPage />} />
        <Route path="/producao/lancamentoProducao" element={<LancamentoProducaoPage />} />
        <Route path="/entrega/produtoAcabado" element={<ProdutoAcabadoPage />} />
        <Route path="/pedidos/pedidoImportacao" element={<PedidosImportacao />} />
        <Route path="/dashboard/otifDashboard" element={<DashboardOtifPage />} />
        <Route path="/dashboard/consumoContratual" element={<DashboardConsumoPage />} />
        <Route path="/dashboard/importacao" element={<DashboardImportPage />} />
        <Route path="/dashboard/acompanhamentoParceiros" element={<UnderConstruction />} />
        <Route path="/estoque/parceirobrf" element={<EstoqueEmbalagensPage />} />
        <Route path="/estoque/parceiro" element={<EstoqueParceiroPage />} />
        <Route path="/teste" element={<ForecastSelection />} />        
      </Routes>
    </React.Fragment>
  );
}

const SUPORTECOPACKERPath = () => {
  return (
    <React.Fragment>
      <Header />
      <Routes>
        <Route path="/" element={<Page />} />
        <Route path="/notfound" element={<NotFound />} />        
        <Route path="/portal/usuario" element={<UsuarioPage />} />
        <Route path="/portal/password" element={<PasswordPage />} />
        
      </Routes>
    </React.Fragment>
  );
}

const PLANEJAMENTOBRFPath = () => {
  return (
    <React.Fragment>
      <Header />
      <Routes>
        <Route path="/" element={<Page />} />
        <Route path="/notfound" element={<NotFound />} />        
        <Route path="/portal/usuario" element={<UsuarioPage />} />
        <Route path="/portal/password" element={<PasswordPage />} />
        <Route path="/planejamento/contratos" element={<RelacaoDeContrato />} />
        <Route path="/contrato/detalhe" element={<ContratoPage />} />
        <Route path="/planejamento/forecast" element={<ForecastPage />} />
        <Route path="/planejamento/forecast?step=3" element={<ForecastPage />} />
        <Route path="/planejamento/forecastDia" element={<ForecastDiarioPage />} />
        <Route path="/planejamento/forecastDia?step=2" element={<ForecastDiarioPage />} />
        <Route path="/planejamento/forecastDia?step=4" element={<ForecastDiarioPage />} />
        <Route path="/producao/lancamentoproducao" element={<LancamentoProducaoPage />} />
        <Route path="/planejamento/materiaprima?step=2" element={<SolicitacaoMaterialPage />} />
        <Route path="/planejamento/materiaprima?step=4" element={<SolicitacaoMaterialPage />} />
        <Route path="/pedidos/pedidoImportacao" element={<PedidosImportacao />} />
        <Route path="/producao/produtoAcabado" element={<ProdutoAcabadoPage />} />
        <Route path="/entrega/produtoAcabado" element={<ProdutoAcabadoPage />} />
        <Route path="/teste" element={<ForecastSelection />} />
        <Route path="/planejamento/projetos" element={<ProjetoPage />} />
        <Route path="/planejamento/justificativa" element={<JustificativasPage />} />
        <Route path="/dashboard/otifDashboard" element={<DashboardOtifPage />} />
        <Route path="/dashboard/consumoContratual" element={<DashboardConsumoPage />} />
        <Route path="/dashboard/importacao" element={<DashboardImportPage />} />
        <Route path="/dashboard/acompanhamentoParceiros" element={<DashboardAcompParceirosPage />} />
        <Route path="/estoque/parceirobrf" element={<EstoqueEmbalagensPage />} />
        <Route path="/estoque/parceiro" element={<EstoqueParceiroPage />} />
        <Route path="/entrega/acompanhamentoFOB" element={<AcompanhamentoCargaFOBPage />} />
        <Route path="/entrega/acompanhamentoCIF" element={<AcompanhamentoCargaCIFPage />} />
        <Route path="/entrega/acompanhamentoMateriaPrima" element={<AcompanhamentoCargaMateriaPrimaPage />} />
      </Routes>
    </React.Fragment>
  );
}

const PLANEJAMENTOCOPAKERPath = () => {
  return (
    <React.Fragment>
      <Header />
      <Routes>
        <Route path="/" element={<Page />} />
        <Route path="/notfound" element={<NotFound />} />
        <Route path="/portal/usuario" element={<UsuarioPage />} />        
        <Route path="/portal/password" element={<PasswordPage />} />
        <Route path="/planejamento/contratos" element={<RelacaoDeContrato />} />
        <Route path="/contrato/detalhe" element={<ContratoPage />} />
        <Route path="/planejamento/forecast" element={<ForecastPage />} />
        <Route path="/planejamento/forecast?step=2" element={<ForecastPage />} />
        <Route path="/planejamento/forecast?step=4" element={<ForecastPage />} />
        <Route path="/planejamento/forecastDia" element={<ForecastDiarioPage />} />
        <Route path="/planejamento/forecastDia?step=1" element={<ForecastDiarioPage />} />
        <Route path="/planejamento/forecastDia?step=3" element={<ForecastDiarioPage />} />
        <Route path="/producao/lancamentoProducao" element={<LancamentoProducaoPage />} />
        <Route path="/producao/lancamentoProducao?step=1" element={<LancamentoProducaoPage />} />
        <Route path="/planejamento/materiaPrima?step=1" element={<SolicitacaoMaterialPage />} />
        <Route path="/planejamento/materiaPrima?step=3" element={<SolicitacaoMaterialPage />} />
        <Route path="/producao/produtoAcabado" element={<ProdutoAcabadoPage />} />
        <Route path="/entrega/produtoAcabado" element={<ProdutoAcabadoPage />} />
        <Route path="/entrega/acompanhamentoFOB" element={<AcompanhamentoCargaFOBPage />} />
        <Route path="/entrega/acompanhamentoCIF" element={<AcompanhamentoCargaCIFPage />} />
        <Route path="/dashboard/acompanhamentoParceiros" element={<UnderConstruction />} />
        <Route path="/teste" element={<ForecastSelection />} />        
      </Routes>
    </React.Fragment>
  );
}

const MATERIAPRIMABRFPath = () => {
  return (
    <React.Fragment>
      <Header />
      <Routes>
        <Route path="/" element={<Page />} />
        <Route path="/notfound" element={<NotFound />} />   
        <Route path="/portal/password" element={<PasswordPage />} />
        <Route path="/portal/usuario" element={<UsuarioPage />} />
        <Route path="/planejamento/materiaPrima" element={<SolicitacaoMaterialPage />} />
        <Route path="/planejamento/materiaPrima?step=2" element={<SolicitacaoMaterialPage />} />
        <Route path="/planejamento/materiaPrima?step=4" element={<SolicitacaoMaterialPage />} />
        <Route path="/producao/produtoAcabado?step=2" element={<ProdutoAcabadoPage />} />
        <Route path="/producao/produtoAcabado?step=4" element={<ProdutoAcabadoPage />} />
        <Route path="/teste" element={<ForecastSelection />} />        
      </Routes>
    </React.Fragment>
  );
}

const MATERIAPRIMACOPAKERPath = () => {
  return (
    <React.Fragment>
      <Header />
      <Routes>
        <Route path="/" element={<Page />} />
        <Route path="/notfound" element={<NotFound />} />
        <Route path="/portal/Password" element={<PasswordPage />} />
        <Route path="/portal/usuario" element={<UsuarioPage />} />
        <Route path="/planejamento/materiaPrima" element={<SolicitacaoMaterialPage />} />
        <Route path="/planejamento/materiaPrima?step=1" element={<SolicitacaoMaterialPage />} />
        <Route path="/planejamento/materiaPrima?step=3" element={<SolicitacaoMaterialPage />} />
        <Route path="/producao/produtoAcabado?step=1" element={<ProdutoAcabadoPage />} />
        <Route path="/producao/produtoAcabado?step=3" element={<ProdutoAcabadoPage />} />
        <Route path="/teste" element={<ForecastSelection />} />        
      </Routes>
    </React.Fragment>
  );
}

export const RotasAutenticadas = () => {
  const user: Usuario = JSON.parse(String(localStorage.getItem("UsuarioCache")));
  let userRegra: Regra = user?.regras[0];
  //console.log(String(userRegra?.descricao?.toLocaleUpperCase()));
  if (!userRegra) {
    if (user && user.id) {
      usuarioDataSet.LimparObjetoDoCache();
      usuarioDataSet.RecuperarPorId(user.id as number).then((usuario) => {
        usuarioDataSet.AdicionarObjetoAoCache(usuario);
        userRegra = usuario?.regras[0];
        return (
          <>
            {userRegra && String(userRegra.descricao?.toLocaleUpperCase()) === "ROOT" ? <RootPath /> : null}
            {userRegra && String(userRegra.descricao?.toLocaleUpperCase()) === "SUPORTEBRF" ? <SUPORTEBRFPath /> : null}
            {userRegra && String(userRegra.descricao?.toLocaleUpperCase()) === "SUPORTECOPACKER" ? <SUPORTECOPACKERPath /> : null}
            {userRegra && String(userRegra.descricao?.toLocaleUpperCase()) === "PLANEJAMENTOBRF" ? <PLANEJAMENTOBRFPath /> : null}
            {userRegra && String(userRegra.descricao?.toLocaleUpperCase()) === "PLANEJAMENTOCOPAKER" ? <PLANEJAMENTOCOPAKERPath /> : null}
            {userRegra && String(userRegra.descricao?.toLocaleUpperCase()) === "MATERIAPRIMABRF" ? <MATERIAPRIMABRFPath /> : null}
            {userRegra && String(userRegra.descricao?.toLocaleUpperCase()) === "MATERIAPRIMACOPAKER" ? <MATERIAPRIMACOPAKERPath /> : null}
          </>
        )
      });
    }
  } else {
    return (
      <>
        {userRegra && String(userRegra.descricao?.toLocaleUpperCase()) === "ROOT" ? <RootPath /> : null}
        {userRegra && String(userRegra.descricao?.toLocaleUpperCase()) === "SUPORTEBRF" ? <SUPORTEBRFPath /> : null}
        {userRegra && String(userRegra.descricao?.toLocaleUpperCase()) === "SUPORTECOPACKER" ? <SUPORTECOPACKERPath /> : null}
        {userRegra && String(userRegra.descricao?.toLocaleUpperCase()) === "PLANEJAMENTOBRF" ? <PLANEJAMENTOBRFPath /> : null}
        {userRegra && String(userRegra.descricao?.toLocaleUpperCase()) === "PLANEJAMENTOCOPAKER" ? <PLANEJAMENTOCOPAKERPath /> : null}
        {userRegra && String(userRegra.descricao?.toLocaleUpperCase()) === "MATERIAPRIMABRF" ? <MATERIAPRIMABRFPath /> : null}
        {userRegra && String(userRegra.descricao?.toLocaleUpperCase()) === "MATERIAPRIMACOPAKER" ? <MATERIAPRIMACOPAKERPath /> : null}
      </>
    )
  }
  return (
    <>
      <RootPath />
    </>
  )
};



